<template>
  <ODialog
    ref="dialog"
    :title="$t('components.review.actions.delete.title')"
    :info="$t('components.review.actions.delete.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirmDelete'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Review } from '~/_api/models/review'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'update:review', value: Review): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref()
const review = ref<Review | null>(null)

const open = (reviewItem: Review) => {
  review.value = reviewItem
  dialog.value.open()
}

const confirm = async () => {
  if (!review.value) return

  emit('update:loading', true)

  try {
    const response = await $api.review.delete(review.value)

    if (response.success) {
      emit('success')
      if (response.data) {
        emit('update:review', response.data)
      }

      $notification.toast({
        title: $i18n.t('components.review.actions.delete.success'),
        text: $i18n.t('components.review.actions.delete.successInfo'),
      })

      return true
    }
  } catch (e: any) {
    console.log(e)

    emit('error')
    $notification.error({ errors: e?.errors })
  }
}

defineExpose({
  open,
})
</script>
